<template>
  <div v-if="voicemail && voicemail.text" class="vmCard">
    <div class="vmHead">
      <span class="vmLabel"><AppIcon name="voicemail" :size="13" />Voicemail Raven left</span>
      <span v-if="when" class="vmTime">{{ when }}</span>
    </div>
    <p class="vmText">“{{ voicemail.text }}”</p>
    <div class="vmFoot">
      <template v-if="fromPretty">Left from {{ fromPretty }} — they may have already heard this.</template>
      <template v-else>They may have already heard this — reference it before you dial.</template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import AppIcon from '../../../components/AppIcon.vue'
import { relativeAgo } from '../../utils/localTime'
import { formatPhone } from '../../utils/phone'
import type { CallerQueueVoicemail } from '../../../services/dialerApi'

// The "Voicemail Raven left" card — shared by the idle focus card and the live
// call card. Sourced from the queue's `voicemail` object (tied to the last
// connect). Shown ONLY when there's an actual agent voicemail script (`text`):
// a human-left VM (voicemail_left disposition) carries no script, so we render
// nothing rather than a meaningless "Voicemail left." placeholder.
const props = defineProps<{ voicemail: CallerQueueVoicemail | null }>()

const when = computed(() => (props.voicemail?.at ? relativeAgo(props.voicemail.at) : ''))
const fromPretty = computed(() =>
  props.voicemail?.from_e164 ? formatPhone(props.voicemail.from_e164) : '',
)
</script>

<style scoped>
.vmCard { border: 1px solid var(--color-border-subtle); border-radius: var(--radius-lg); background: var(--color-bg-surface); padding: var(--space-4) var(--space-5); box-shadow: var(--shadow-sm); }
.vmHead { display: flex; align-items: baseline; justify-content: space-between; gap: var(--space-3); margin-bottom: var(--space-2); }
.vmLabel { display: inline-flex; align-items: center; gap: 6px; font-size: var(--fs-xs); font-weight: var(--fw-semibold); letter-spacing: var(--tracking-wide); text-transform: uppercase; color: var(--color-text-tertiary); }
.vmTime { font-size: var(--fs-xs); color: var(--color-text-tertiary); white-space: nowrap; }
.vmText { font-size: var(--fs-base); line-height: var(--lh-loose); color: var(--color-text-primary); }
.vmFoot { margin-top: var(--space-3); font-size: var(--fs-xs); color: var(--color-text-tertiary); }
</style>
